module.exports = __webpack_public_path__ + "img/placeholder-min.f9b64598.png";